import $ from 'jquery';
import _ from 'underscore';
import Model from 'cdna/core/model';

export default Model.extend({
    defaults() {
        return {    
            Name: _.uniqueId('faq'),
            toggled: false
        }
    },
    idAttribute: 'Name',
    initialize() {
        this.assignHtmlFromPath();
        this.on('change:HtmlPath', this.assignHtmlFromPath, this);
    },
    assignHtmlFromPath() {        
        var path = this.get('HtmlPath');
        if (!path) return;

        $.get(path).done(html => {                
            this.set('Html', html);
        });
    }
});



/** WEBPACK FOOTER **
 ** ./client/faq/faqEntryModel.js
 **/